const BASE_URL = "https://collectionapi.metmuseum.org/public/collection/v1";

export async function apiGet(endpoint) {
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`);

    if (!response.ok) {
      throw new Error(
        `Erro ao acessar ${endpoint}: HTTP ${response.status}`
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Erro na chamada de API:", error.message);
    return null; // segurança: evita crash
  }
}
